<template>
  <div>
    <main-layout>
      <v-container>
        <v-layout>
          <v-flex>
            <h3 class="headline">{{ $t('Comment to Inbox') }}</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <transfer-intent type="replycomment" :intents="intents"></transfer-intent>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12 sm6 class="form-control">
            <input
              v-model="search"
              type="text"
              class="form-control"
              :placeholder="$t('Search Comment to inbox')"
              style="margin-bottom: 10px"
              @keydown.enter="onSearch"
              @input="onSearch"
            />
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn outline color="primary" @click="expandAll">
              <em class="fas fa-expand-arrows-alt mr-1" />
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn outline color="primary" @click="collapseAll">
              <em class="fas fa-compress mr-1" />
              {{ $t('Collapse All') }}
            </v-btn>
          </v-flex>
        </v-layout>

        <div>
          <div style="margin-bottom: 10px">
            <a v-if="!isShow" href="javascript:void(0);" @click="addCommentToInbox">
              <div class="add-conversation text-xs-center">
                <em class="fa fa-plus middle" />
                {{ $t('Add Comment to inbox') }}
              </div>
            </a>

            <div v-else class="intent-item z-border-red" style="padding: 10px 15px 0px">
              <manage-intent
                v-model="intent"
                :is-comment-to-inbox="true"
                :type="'add'"
                :excluded-intent-name="excludedIntentName"
                @close="onClose"
                @saveIntent="onSaveIntent"
              ></manage-intent>
            </div>
          </div>

          <Pagination
            :key="timestamp"
            v-model="pageNumber"
            :limit="limit"
            :total="total"
            @onChange="handleChangePage"
          >
            <intent-item
              v-for="(item, index) in filterIntents"
              :key="'intent_' + item.id + '_' + index"
              v-model="filterIntents[index]"
              :is-comment-to-inbox="true"
              :filter-intents="filterIntents"
              :excluded-intent-name="excludedIntentName"
              @onDelete="deleteIntent(index)"
              @onCopyIntent="copyIntent"
              @onUpdate="onUpdateIntent"
            ></intent-item>
            <div v-if="filterIntents.length == 0" class="my-4 text-xs-center">
              {{ $t('No data') }}
            </div>
          </Pagination>
        </div>
      </v-container>
      <v-divider></v-divider>

      <div style="position: relative">
        <v-container>
          <!-- <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup> -->
          <h3 class="headline">{{ $t('More Comment to Inbox') }}</h3>
          <transition name="fade">
            <div v-if="default_comment_to_inbox" class="col s12">
              <intent-item
                v-model="default_comment_to_inbox"
                :is-comment-to-inbox="true"
                :is-default="true"
                :excluded-intent-name="excludedIntentName"
                @onDelete="deleteIntent(index)"
                @onUpdate="onUpdateIntent"
              ></intent-item>
            </div>
          </transition>
        </v-container>
      </div>
      <div class="mt-5 mb-5"></div>
    </main-layout>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import TransferIntent from './TransferIntent'
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import intentItem from './intent-item'
import api from '@/api'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'
import Pagination from '@/components/elements/Pagination2.vue'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    TransferIntent,
    Pagination
  },

  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  },
  data() {
    return {
      isShow: false,
      showModal: false,

      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      },
      allIntents: [],
      intents: [],
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_comment_to_inbox: undefined,
      limit: 20,
      offset: 0,
      total: 0,
      search: '',
      searchTimeout: null,
      pageNumber: 1,
      timestamp: moment().format('x')
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntents: function () {
      var vm = this
      if (vm.selectedBot.theme !== 'tero') {
        vm.intents.sort(function (a, b) {
          var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
          var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
          if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
            return 1
          }
          if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
            return -1
          }
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
      }

      return vm.intents
    },
    excludedIntentName: function () {
      var result = []
      var vm = this
      if (vm.allIntents) {
        vm.allIntents.map(function (intent) {
          result.push(intent.intentname)
        })
      }
      return result.join(',')
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter((el) => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.intentname
        )
      })
      return intentwithoutwelcome.length
    }
  },
  async mounted() {
    var vm = this

    vm.$store.dispatch('loading')
    try {
      await vm.getWelcomeMessage()
    } catch (error) {
      console.error(error)
    }
    await vm.getIntent()
    await this.handleInitDefaultMessage()
    vm.$store.dispatch('loading')
    if (this.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    if (vm.$store.state.toaPaintPage.includes(vm.selectedBot.pageid)) {
      vm.$store.dispatch('loadGroupConversation')
    }
    vm.$store.dispatch('loadSetting')
  },
  methods: {
    async handleChangePage(payload) {
      this.$store.dispatch('loading')
      this.offset = payload.offset
      await this.getIntent()
      this.$store.dispatch('loading')
    },
    onSearch() {
      const vm = this
      if (vm.searchTimeout) {
        clearTimeout(vm.searchTimeout)
      }
      if (vm.loading) return false
      vm.searchTimeout = setTimeout(async () => {
        vm.$store.dispatch('loading')
        try {
          vm.offset = 0
          vm.pageNumber = 1
          vm.timestamp = moment().format('x')
          await vm.getIntent()
        } catch (error) {
          console.error(error)
        }
        vm.$store.dispatch('loading')
        vm.searchTimeout = null
      }, 1000)
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    async onSaveIntent(payload) {
      var vm = this
      vm.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      vm.isShow = false
      payload.isShow = true
      vm.intents.push(payload)

      await this.handleChangeIntent({ intent_name: payload.intent_name })
      vm.allIntents.push(payload)
      vm.intent = cloneDeep(vm.intentTemplate())
      vm.lastedIntentName = payload.intentname
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        // eslint-disable-next-line no-useless-escape
        title: `${vm.$t('conversation')} "${
          payload.intentname ? payload.intentname.replace(/\<|\>/g, '') : ''
        }" ${vm.$t('added')}`,
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
    },
    copyIntent: function (payload) {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</strong>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault.length >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t('Please contact us')}</strong>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then((result) => {
          result.isShow = true
          this.intents.push(result)
          this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              // eslint-disable-next-line no-useless-escape
              result.intentname.replace(/\<|\>/g, '') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        })
      }
    },
    onClose: function () {
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      this.isShow = false
    },
    async getIntent(intentType = 'comment', intent_name = []) {
      let data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset,
        page_intent: intentType,
        search_intent: this.search && this.search.trim() ? this.search.trim() : undefined,
        intent_name:
          intent_name.length > 0 ? `[${intent_name.map((el) => `"${el}"`).join(',')}]` : undefined,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }

      try {
        this.total = 0
        const response = await intentApi.getIntent({ params: data })
        await handleResponse(response)
        if (response.status == 200 && response.data.data) {
          const intents = response.data.data.map(function (val) {
            return { ...val, isShow: false, ableToDelete: true }
          })

          this.total = response.data.total_count || 0
          this.allIntents = intents

          this.intents = intents.filter((el) => {
            return (
              el.context_in == 'comment' &&
              el.intentname != '{default_comment_to_inbox}' &&
              el.intentname != '{welcome}'
            )
          })
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleInitDefaultMessage(
      intentType = 'comment',
      intent_name = ['{default_comment_to_inbox}']
    ) {
      let data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset,
        page_intent: intentType,
        search_intent: this.search && this.search.trim() ? this.search.trim() : undefined,
        intent_name: `[${intent_name.map((el) => `"${el}"`).join(',')}]`,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      const response = await intentApi.getIntent({ params: data })
      await handleResponse(response)
      if (response.status == 200 && response.data.data) {
        const intents = response.data.data.map(function (val) {
          return { ...val, isShow: false, ableToDelete: true }
        })
        var default_comment_to_inbox = intents.find((el) => {
          return el.intentname == '{default_comment_to_inbox}'
        })

        if (default_comment_to_inbox) {
          default_comment_to_inbox.ableToDelete = false
          this.default_comment_to_inbox = default_comment_to_inbox
        } else {
          this.default_comment_to_inbox = {
            ...cloneDeep(this.intentTemplate()),
            intentname: '{default_comment_to_inbox}',
            q_val: '{default}'
          }
        }
      }
    },
    async handleChangeIntent({ intent_name }) {
      switch (intent_name) {
        case '{default}':
        case '{default_comment_to_inbox}':
        case '{default_live}':
          await this.handleInitDefaultMessage()
          break
        default:
          await this.getIntent()
          break
      }
    },
    async deleteIntent(index) {
      const result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          // eslint-disable-next-line no-useless-escape
          name: this.filterIntents[index].intentname.replace(/\<|\>/g, '')
        }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        let data = {
          id: this.filterIntents[index].id,
          pageid: this.selectedBot.pageid
        }
        this.$store.dispatch('loading')
        try {
          const response = await intentApi.deleteIntent({ params: data })
          await handleResponse(response)
          await this.handleChangeIntent({ intent_name: this.filterIntents[index].intent_name })
          this.$store.dispatch('clear_loading')
        } catch (error) {
          this.$store.dispatch('clear_loading')
          handleApiError(error)
        }
      }
    },
    addCommentToInbox() {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</strong>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t('Please contact us')}</strong>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      }
    },
    getWelcomeMessage: function () {
      let vm = this
      let data = {
        pageid: vm.currentpageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      return new Promise((resolve, reject) => {
        api.getWelcomeMessage(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.welcome_message.type = response.data.type
            vm.welcome_message.message = response.data.message_text
              ? response.data.message_text
              : ''

            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              vm.welcome_message.generics = response.data.message.map((message) => message, [])
            }

            if (
              response.data.message_quickreplies &&
              response.data.message_quickreplies != '' &&
              response.data.message_quickreplies != null
            ) {
              vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
            } else {
              vm.welcome_message.quick_reply = []
            }
          }
          resolve()
        })
      })
    },
    expandAll: function () {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', true)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', true)
    },
    collapseAll: function () {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', false)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', false)
    },
    onUpdateIntent: function (payload) {
      var vm = this
      vm.intents.forEach((intent, index) => {
        if (intent.id == payload.id) {
          vm.intents[index] = payload
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/CommentToInbox.vue